import React, { Component, Fragment } from "react";
import { withStyles } from "@material-ui/core";
import { Link } from "react-router";
import {
  PLAY_STORE_LINK,
  APP_STORE_LINK,
  PH_HOST,
  MY_HOST,
  E_STORE_LINK,
  ZAP_DEALS_LINK,
} from "config";

const useStyle = (theme) => ({
  container: {
    position: "relative",
    zIndex: "1",
    display: "flex",
    justifyContent: "center",
    width: "100%",
    height: "242px",
    background: "#2B2B2B",
    gap: "40px",
    padding: "56px 80px",

    "@media (max-width:1439px)": {
      padding: "56px",
    },

    "@media (max-width:1251px)": {
      padding: "40px",
      height: "auto",
      flexDirection: "column",
      alignItems: "flex-start",
    },

    "@media (max-width:990px)": {
      padding: "40px 24px",
    },
  },

  bottomLogo: {
    width: "200px",
    height: "72px",
    cursor: "pointer",
  },

  linkContainer: {
    display: "flex",
    gap: "80px",
    width: "100%",
    maxWidth: "472px",

    "@media (max-width:478px)": {
      gap: "40px",
      flexDirection: "column",
    },
  },

  linkColumn: {
    display: "flex",
    flexDirection: "column",
    color: "#FFFFFF",
    gap: "24px",

    "& span": {
      fontFamily: "manrope-regular-webfont",
      fontSize: "12px",
      fontStyle: "normal",
      fontWeight: "700",
      lineHeight: "18px",
      letterSpacing: "1.2px",
    },

    "& a": {
      fontFamily: "manrope-regular-webfont",
      fontSize: "16px",
      fontStyle: "normal",
      fontWeight: "600",
      lineHeight: "24px",
      cursor: "pointer",
    },

    "& div": {
      display: "flex",
      flexDirection: "column",
      gap: "8px",
    },
  },

  appContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",

    "& img": {
      width: "157px",
      height: "48px",
      cursor: "pointer",
    },

    "@media (max-width:1251px)": {
      flexDirection: "row",
    },

    "@media (max-width:478px)": {
      flexDirection: "column",
    },
  },

  endContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    width: "100%",
    maxWidth: "190px",
    alignItems: "flex-end",

    "@media (max-width:1251px)": {
      alignItems: "flex-start",
    },

    "& span": {
      textAlign: "right",
      color: "#FFFFFF",
      fontFamily: "manrope-regular-webfont",
      fontSize: "12px",
      fontStyle: "normal",
      fontWeight: "600",
      lineHeight: "18px",
    },
  },

  flags: {
    display: "inline-flex",
    gap: "16px",

    "& img": {
      height: "40px",
      width: "40px",
      borderRadius: "100%",
      cursor: "pointer",
    },
  },

  socials: {
    display: "inline-flex",
    gap: "8px",
    "& img": {
      cursor: "pointer",
      width: "20px",
      height: "20px",
    },
  },
});

class PhFooter extends Component {
  render() {
    const { classes } = this.props;
    return (
      <Fragment>
        <div className={classes.container}>
          <div className={classes.bottomLogo}>
            <Link to={"/"}>
              <img src={require("./images/zap_logo_loyalty_white.svg")} />
            </Link>
          </div>
          <div className={classes.linkContainer}>
            <div className={classes.linkColumn}>
              <span>PRODUCTS</span>
              <div>
                <Link to={"/"}>ZAP Loyalty</Link>
                <Link to={E_STORE_LINK} target="_blank">
                  ZAP E-Store
                </Link>
                <Link to={ZAP_DEALS_LINK} target="_blank">
                  ZAP Deals
                </Link>
              </div>
            </div>
            <div className={classes.linkColumn}>
              <span>RESOURCES</span>
              <div>
                <Link to={"https://blog.zapestore.com"} target="_blank">
                  Blog
                </Link>
                <Link to={"/contact"}>Contact Us</Link>
              </div>
            </div>
            <div className={classes.linkColumn}>
              <span>LEGAL</span>
              <div>
                <Link to={"terms"}>Terms</Link>
                <Link to={"/privacy"}>Privacy</Link>
              </div>
            </div>
          </div>
          <div className={classes.appContainer}>
            <Link to={APP_STORE_LINK} target="_blank">
              <img src={require("./images/applestore_white.svg")} />
            </Link>
            <Link to={PLAY_STORE_LINK} target="_blank">
              <img src={require("./images/google_play_white.svg")} />
            </Link>
          </div>
          <div className={classes.endContainer}>
            <div className={classes.flags}>
              <a href={`//${PH_HOST}`}>
                <img src={require("./images/flag-philippines.png")} />
              </a>
              <a href={`//${MY_HOST}`}>
                <img src={require("./images/flag-malaysia.png")} />
              </a>
            </div>
            <div className={classes.socials}>
              <Link
                to={"https://www.facebook.com/PoweredByZAP"}
                target="_blank"
              >
                <img src={require("./images/dark_fb.svg")} />
              </Link>
              <Link to={"https://instagram.com/poweredbyzap"} target="_blank">
                <img src={require("./images/dark_insta.svg")} />
              </Link>
            </div>
            <span>2012-{new Date().getFullYear()} All rights reserved.</span>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default withStyles(useStyle())(PhFooter);



// WEBPACK FOOTER //
// ./js/components/PhFooter.js